export default __webpack_public_path__ + "static/media/tiagocarcao.ff6f14a9.png";